import { useCallback } from 'react';
import { useEditFormSection } from './FormSection.hooks';
export function useEditFormElement(trackChanges, formState, notifyFormEdit) {
    const { getStateNodePath } = useEditFormSection(trackChanges, formState, notifyFormEdit);
    const { insert, move, remove, update } = trackChanges;
    const getSelectedElementPath = useCallback(() => {
        var _a;
        const { selectedStateNode, selectedFormElement } = formState;
        if (!((_a = selectedStateNode === null || selectedStateNode === void 0 ? void 0 : selectedStateNode.meta) === null || _a === void 0 ? void 0 : _a.elements) || !selectedFormElement) {
            throw new Error('No selected form element');
        }
        const path = getStateNodePath(selectedStateNode);
        const index = selectedStateNode.meta.elements.indexOf(selectedFormElement);
        return `${path}.meta.elements[${index}]`;
    }, [formState, getStateNodePath]);
    const addElement = useCallback((stateNode, element, index) => {
        if (!element) {
            element = {
                type: formState.lastFormElementType,
                key: 'question',
                title: `Question`
            };
        }
        const stateNodePath = getStateNodePath(stateNode);
        // if (!stateNode.meta) {
        //   update(`${stateNodePath}.meta`, createFormSectionMeta());
        // }
        // if (!stateNode.meta?.elements) {
        //   update(`${stateNodePath}.meta.elements`, []);
        // }
        if (typeof index === 'undefined') {
            index = stateNode.meta.elements.length;
        }
        insert(`${stateNodePath}.meta.elements[${index + 1}]`, element);
        // Needed for UI to refresh
        // setTimeout(() => {
        //   setFormState(formState => ({
        //     ...formState,
        //     selectedStateNode: stateNode,
        //     selectedFormElement: element
        //   }));
        // });
        notifyFormEdit();
    }, [
        getStateNodePath,
        insert,
        formState.lastFormElementType,
        // setFormState,
        notifyFormEdit
    ]);
    const updateElement = useCallback((element) => {
        Object.keys(element).forEach(key => {
            update(`${getSelectedElementPath()}.${key}`, element[key]);
        });
        notifyFormEdit();
    }, [getSelectedElementPath, notifyFormEdit, update]);
    const moveElement = useCallback((sourceIndex, destinationIndex) => {
        const { selectedStateNode } = formState;
        const path = getStateNodePath(selectedStateNode);
        move(`${path}.meta.elements`, sourceIndex, destinationIndex);
    }, [formState, getStateNodePath, move]);
    const deleteElement = useCallback(() => {
        remove(getSelectedElementPath());
        notifyFormEdit();
    }, [getSelectedElementPath, notifyFormEdit, remove]);
    /**
     * Add an action for an element. If no selement provided, then use selected element.
     */
    const addElementAction = useCallback((action) => {
        const { selectedFormElement } = formState;
        const fullPath = getSelectedElementPath();
        if (!(selectedFormElement === null || selectedFormElement === void 0 ? void 0 : selectedFormElement.actions)) {
            update(`${fullPath}.actions`, []);
        }
        insert(`${fullPath}.actions`, action);
        notifyFormEdit();
    }, [formState, getSelectedElementPath, insert, notifyFormEdit, update]);
    /**
     * Update an action for an element. If no element provided, then use selected element
     */
    const updateElementAction = useCallback((index, action) => {
        const fullPath = getSelectedElementPath();
        update(`${fullPath}.actions[${index}]`, action);
        notifyFormEdit();
    }, [getSelectedElementPath, notifyFormEdit, update]);
    /**
     * Reorder an element action. If no element provided, then use selected element.
     */
    const moveElementAction = useCallback((sourceIndex, destinationIndex) => {
        const fullPath = getSelectedElementPath();
        move(`${fullPath}.actions`, sourceIndex, destinationIndex);
        notifyFormEdit();
    }, [getSelectedElementPath, move, notifyFormEdit]);
    /**
     * Delete an element action
     */
    const deleteElementAction = useCallback((index) => {
        const fullPath = getSelectedElementPath();
        remove(`${fullPath}.actions[${index}]`);
        notifyFormEdit();
    }, [getSelectedElementPath, notifyFormEdit, remove]);
    return {
        addElement,
        updateElement,
        moveElement,
        deleteElement,
        addElementAction,
        updateElementAction,
        moveElementAction,
        deleteElementAction
    };
}
//# sourceMappingURL=FormElement.hooks.js.map